import script from "./configurations.vue?vue&type=script&setup=true&lang=ts"
export * from "./configurations.vue?vue&type=script&setup=true&lang=ts"

import "./configurations.vue?vue&type=style&index=0&id=2db48cde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db48cde"]])

export default __exports__